(function () {
  'use strict';

  function CollectionCategoryList(section) {
    this.section = section;
    this.slider = section.querySelector('.collection-category-list__slider');
    if (!this.slider) return;
    this.init();
  }

  CollectionCategoryList.prototype.init = function () {
    // Ready for future enhancements (drag scroll, indicators, etc.)
  };

  document.querySelectorAll('.collection-category-list').forEach(function (section) {
    new CollectionCategoryList(section);
  });
})();
